import(/* webpackMode: "eager" */ "/app/app/[locale]/template.tsx");
